import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "not-found" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h1", null, "404 – Seite nicht gefunden", -1)),
    _cache[1] || (_cache[1] = _createElementVNode("p", null, "Die Seite, die Sie aufrufen wollten, existiert nicht oder wurde verschoben.", -1)),
    _createVNode(_component_router_link, {
      class: "home-button",
      to: "/"
    }, {
      default: _withCtx(() => [
        _createTextVNode("Zur " + _toDisplayString(_ctx.STRINGS.HOME), 1)
      ]),
      _: 1
    })
  ]))
}